import { render } from "./singleExpertFeature.vue?vue&type=template&id=5663e2a1&scoped=true"
import script from "./singleExpertFeature.vue?vue&type=script&lang=js"
export * from "./singleExpertFeature.vue?vue&type=script&lang=js"

import "./singleExpertFeature.vue?vue&type=style&index=0&id=5663e2a1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5663e2a1"]])

export default __exports__